import { isBrowser } from '../generic';

const articleTrackPageView = (
  author: string,
  tags: string[],
  title: string,
  pubDate: string,
  lastModDate: string,
  readTime: string
) => {
  if (!isBrowser || !window.aabAnalytics) return;

  window.aabAnalytics.push({
    command: 'ADD EVENT',
    name: 'pageview',
    data: {
      page_url: window.location.href,
      page_language: 'nl',
      page_type: 'article',
      page_template: 'page article',
      page_author: author,
      page_tags: tags,
      page_article_title: title,
      page_date_publication: pubDate,
      page_date_last_modified: lastModDate,
      page_reading_time: readTime,
      page_channel: 'open domain', // Linkedin
    },
  });
};

export default articleTrackPageView;
